import WithProductGeneralSearchPanel from "./withProductGeneralSearch.container";

export default WithProductGeneralSearchPanel;
